<!-- app-subdomain-creators/src/layouts/LayoutSwitcher.vue -->
<template>
  <div>
    <transition name="fade" mode="out-in">
      <component :is="currentLayout" :key="route.meta.layout || route.fullPath" />
    </transition>
  </div>
</template>

<script setup>
import { shallowRef, provide, watch, markRaw } from 'vue'
import { useRoute } from 'vue-router'

import CreatorLayout from './CreatorLayout.vue'
import DefaultLayout from './DefaultLayout.vue'
import PageThemeEditorLayout from './PageThemeEditorLayout.vue'
import SitePageEditorLayout from './SitePageEditorLayout.vue'

const layoutMap = {
  creator: markRaw(CreatorLayout),
  default: markRaw(DefaultLayout),
  'page-theme-editor': markRaw(PageThemeEditorLayout),
  'site-page-editor': markRaw(SitePageEditorLayout),
}

const currentLayout = shallowRef(layoutMap.creator)

// Layout switcher functions
const switchToDefaultLayout = () => (currentLayout.value = layoutMap.default)
const switchToCreatorLayout = () => (currentLayout.value = layoutMap.creator)
const switchToPageThemeEditorLayout = () => (currentLayout.value = layoutMap['page-theme-editor'])
const switchToSitePageEditorLayout = () => (currentLayout.value = layoutMap['site-page-editor'])

// Provide these globally (so you can call them in any component)
provide('switchToDefaultLayout', switchToDefaultLayout)
provide('switchToCreatorLayout', switchToCreatorLayout)
provide('switchToPageThemeEditorLayout', switchToPageThemeEditorLayout)
provide('switchToSitePageEditorLayout', switchToSitePageEditorLayout)

// Auto-switch when route changes (using meta.layout)
const route = useRoute()

watch(
  () => route.meta.layout,
  (layout) => {
    switch (layout) {
      case 'creator': switchToCreatorLayout(); break
      case 'default': switchToDefaultLayout(); break
      case 'page-theme-editor': switchToPageThemeEditorLayout(); break
      case 'site-page-editor': switchToSitePageEditorLayout(); break
      default: switchToCreatorLayout(); break
    }
  },
  { immediate: true }
)


</script>

<style>
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>

  
  
  
  
